import { useMutation } from '@tanstack/react-query';
import type { CandidateEndpointBulkCommentPostRequest } from '../types/CandidateProfile';

export default function usePostCandidateEndpointBulkComment() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({
      candidateProfileId,
      comment,
    }: CandidateEndpointBulkCommentPostRequest) => {
      const response = await fetch(
        `/agent/api/candidate_endpoints/${candidateProfileId}/bulk_comment`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-CSRF-Token': token,
          },
          body: JSON.stringify({ comment }),
        }
      );
      const data = await response.json();
      return data;
    },
  });
}
